/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationQuoteRequestEx as ModelsV3ApplicationApplicationQuoteRequestEx } from '../../models/Models/v3/Application/application-quote-request-ex';
import { ApplicationQuoteResponseBaseResponse as ModelsV3ApplicationApplicationQuoteResponseBaseResponse } from '../../models/Models/v3/Application/application-quote-response-base-response';

export interface V4ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Params {
  applicationId: string;
      body?: ModelsV3ApplicationApplicationQuoteRequestEx
}

export function v4ApplicationsApplicationIdInsuranceQuotePost$Json$Json(http: HttpClient, rootUrl: string, params: V4ApplicationsApplicationIdInsuranceQuotePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4ApplicationsApplicationIdInsuranceQuotePost$Json$Json.PATH, 'post');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3ApplicationApplicationQuoteResponseBaseResponse>;
    })
  );
}

v4ApplicationsApplicationIdInsuranceQuotePost$Json$Json.PATH = '/v4/applications/{applicationId}/insurance/quote';
